import SmartBookingManage from './SmartBookingManage';
import React, {useCallback,useEffect,useRef,useState} from 'react';
import SmartBookingUpload from './SmartBookingUpload';

const format=value=>new Intl.DateTimeFormat('de-DE',{dateStyle:'full',timeStyle:'short',timeZone:'Europe/Berlin'}).format(new Date(value));
function previousDay(value) {
  if (!value) return undefined;
  const parts=new Intl.DateTimeFormat('sv-SE',{timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date(value));
  const day=new Date(parts+'T12:00:00Z');day.setUTCDate(day.getUTCDate()-1);
  return day.toISOString().slice(0,10);
}
async function request(path,body) {
  const r=await fetch('/api/smart-booking/'+path,{method:'POST',credentials:'omit',headers:{
    'Content-Type':'application/json','X-SM-Request':'1'},body:JSON.stringify(body)});
  const data=await r.json();
  if(!r.ok) throw new Error(typeof data.detail==='string'?data.detail:'Buchung gerade nicht möglich.');
  return data;
}

export default function SmartBooking() {
  const [token]=useState(()=>window.location.hash.slice(1));
  const valid=Boolean(token);
  const [data,setData]=useState(null),[selected,setSelected]=useState(''),[due,setDue]=useState('');
  const [files,setFiles]=useState([]),[uploading,setUploading]=useState(false),[busy,setBusy]=useState(false);
  const [error,setError]=useState(''),[done,setDone]=useState(null);
  const pending=useRef(false);
  const load=useCallback(async()=>{
    if (!valid) return;
    setError('');setSelected('');setData(null);setFiles([]);setDue('');
    try {
      const result=await request('slots',{token});
      if(result.booked||result.cancelled) setDone(result); else setData(result);
    } catch(e){setError(e.message);}
  },[token,valid]);
  useEffect(()=>{load();},[load]);
  const needsDue=data?.document_due_required&&!files.length;
  const latest=previousDay(selected);
  const dateValid=!needsDue||(due&&due>=data.today&&due<=latest);
  async function book() {
    if(!selected||uploading||pending.current||!dateValid) return;
    pending.current=true;setBusy(true);setError('');
    try {
      const payload={token,start_at:selected};
      if (data.document_due_required) {
        if (files.length) payload.file_ids=files; else payload.document_due=due;
      }
      const result=await request('book',payload);
      setDone({...result,can_manage:!!data.today,documents_reviewed:data.documents_reviewed,uploaded:!!files.length,document_due:files.length?null:due});
    } catch(e){setError(e.message);}
    finally{pending.current=false;setBusy(false);}
  }
  let note='Bitte stellen Sie Ihrem Ansprechpartner Ihre Energieunterlagen spätestens einen Tag vorher bereit.';
  if(done?.documents_reviewed) note='Ihre Unterlagen wurden bereits geprüft.';
  else if(done?.uploaded) note='Ihre hochgeladenen Unterlagen liegen zur fachlichen Prüfung vor.';
  else if(done?.document_due) note='Bitte senden Sie Ihre Jahresabrechnung bis zum '+done.document_due.split('-').reverse().join('.')+'.';
  return <main className="min-h-screen bg-slate-950 text-slate-100 p-5 sm:p-10"><div className="max-w-xl mx-auto space-y-6">
    <p className="text-amber-300 tracking-widest text-sm">LÖWENSTARK · ENERGIEBERATUNG</p>
    <h1 className="text-3xl font-serif">Zeit für Ihre Energieversorgung.</h1>
    {!valid?<p>Für die Terminbuchung benötigen Sie die persönliche Einladung Ihres Ansprechpartners.</p>:
     done?.cancelled?<p role="status">Ihr Termin ist abgesagt. Ihr Ansprechpartner übernimmt die persönliche Neuterminierung.</p>:done?<div role="status" className="rounded-2xl border border-amber-500/30 p-6">
      <h2 className="text-xl">Ihr Beratungstermin ist vereinbart.</h2><p className="mt-3">{format(done.start_at)} · {done.duration} Minuten</p>
      <p className="mt-3">{note}</p>
      {done.can_manage?<SmartBookingManage token={token} appointment={done} request={request} format={format} onDone={setDone}/>:<p>Für Änderungen wenden Sie sich bitte direkt an Ihren Ansprechpartner.</p>}
     </div>:<>
      <p>Wählen Sie einen passenden Termin{data?.advisor?' mit '+data.advisor:''}. Alle Zeiten gelten für Deutschland.</p>
      {data?.today&&<p>Sie möchten noch heute sprechen? Rufen Sie mich gerne an.{data.advisor_phone&&
        <> <a href={'tel:'+data.advisor_phone.replace(/[^+\d]/g,'')}>{data.advisor_phone}</a></>}</p>}
      {error&&<p role="alert" className="text-red-300">{error} <button disabled={busy||uploading} className="underline" onClick={load}>Erneut laden</button></p>}
      {!data&&!error&&<p role="status">Freie Termine werden geprüft …</p>}
      {data&&<><label className="block">Freier Beratungstermin<select className="w-full mt-2 p-3 rounded-xl bg-slate-900 border border-slate-600"
        value={selected} onChange={e=>setSelected(e.target.value)} disabled={busy}>
        <option value="">Bitte auswählen</option>{data.slots.map(v=><option key={v} value={v}>{format(v)}</option>)}</select></label>
        {data.document_due_required&&data.upload_available&&<SmartBookingUpload token={token} request={request} disabled={busy}
          selected={files} onBusy={setUploading} onChoose={(id,checked)=>setFiles(old=>checked?[...new Set([...old,id])]:old.filter(v=>v!==id))}/>}
        {needsDue&&<label className="block">Bis wann senden Sie Ihre letzte Jahresabrechnung? Spätestens am Vortag des Termins.
          <input required type="date" value={due} min={data.today} max={latest} onChange={e=>setDue(e.target.value)}/></label>}
        {!data.slots.length&&<p>Derzeit ist kein freier Termin verfügbar. Bitte kontaktieren Sie Ihren Ansprechpartner persönlich.</p>}
        <button disabled={!selected||busy||uploading||!dateValid} onClick={book} className="w-full rounded-xl p-4 bg-amber-300 text-slate-950 font-semibold disabled:opacity-50">
          {busy?'Termin wird gespeichert …':'Beratungstermin verbindlich buchen'}</button>
        <p className="text-sm text-slate-400">Mit der Buchung wird ein Beratungstermin vereinbart. Sie schließen damit keinen Energievertrag ab.</p>
      </>}
    </>}
  </div></main>;
}
